// CRA 5 no genera service-worker.js. Solo desregistramos SW legados para evitar 404 y caché obsoleta.

export default function register() {
  unregister();
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
